import { ReactElement, useMemo } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';

import GenerateRouteCompletedTabs from '~components/GenerateRouteCompletedTabs';
import { useGenerateRouteStepperData, useUtcOffset } from '~hooks/index';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../../Context';

const AssistantGenerateRoutesDialogByTemplateContentStepperTab =
  (): ReactElement => {
    const formatterDateUtcOffset = useUtcOffset();

    const {
      stepper: {
        currentApiTransactionId: { value: currentApiTransactionId },
      },
      actions,
    } = useAssistantGenerateRoutesDialogByTemplateContext();

    const {
      data,
      loadingData,
      indicators,
      loadingIndicators,
      totalStops,
      totalVehicles,
      errors,
    } = useGenerateRouteStepperData({
      apiTransactionId: currentApiTransactionId as string,
      onSuccessComplete: actions?.onStepperComplete,
    });

    const title = useMemo(
      () =>
        `Plan de viaje ${data?.name ?? ''} (${formatterDateUtcOffset(
          data?.scheduledDateTime,
          'DD/MM/YYYY HH:mm',
        )})`,
      [data, formatterDateUtcOffset],
    );

    if (loadingData) {
      return (
        <Stack flex={1} justifyContent="center" alignItems="center">
          <CircularProgress color="primary" disableShrink size={60} />
        </Stack>
      );
    }

    return (
      <Stack spacing={2} flex={1}>
        <Typography variant="h6" component="h2" color="text.primary">
          {title}
        </Typography>

        <Stack spacing={2}>
          <GenerateRouteCompletedTabs
            workProgressId={3}
            indicators={indicators}
            loadingIndicators={loadingIndicators}
            errors={errors}
            totalStops={totalStops}
            totalVehicles={totalVehicles}
            type="generate"
          />
        </Stack>
      </Stack>
    );
  };

export default AssistantGenerateRoutesDialogByTemplateContentStepperTab;
